export default {
    state: {
        expirationDate: localStorage.getItem('expirationDate') === 0 ? 0 : localStorage.getItem('expirationDate'),
    },
    mutations: {
        setExpirationDate(state, expirationDate) {
            state.expirationDate = expirationDate;
        }  
    },
    actions: {
        setExpirationDate({commit}, expirationDate) {
            localStorage.setItem('expirationDate', expirationDate)
            commit('setExpirationDate', expirationDate);
        }
    },
};